import { render, staticRenderFns } from "./FakeFooter.vue?vue&type=template&id=5a7b0b58&"
import script from "./FakeFooter.vue?vue&type=script&lang=js&"
export * from "./FakeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports